import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const OAuth2Callback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Parse token from the URL hash
    const hash = window.location.hash.substring(1);
    const params = new URLSearchParams(hash);
    const accessToken = params.get("access_token");

    if (accessToken) {
      // Save token for later API calls
      localStorage.setItem("googleAccessToken", accessToken);
      alert("✅ Google Calendar linked successfully!");
    } else {
      alert("⚠️ Failed to connect Google Calendar.");
    }

    // Redirect back to home or dashboard
    navigate("/home");
  }, [navigate]);

  return <div>Processing Google OAuth...</div>;
};

export default OAuth2Callback;
